export default __webpack_public_path__ + "static/media/gray-check.972837e2.svg";